// removed by extract-text-webpack-plugin
module.exports = {"PopupContent":"styles__PopupContent___2jxJ4","PopupTitle":"styles__PopupTitle___VRBIl","PopupBody":"styles__PopupBody___1JE1k","PopupText":"styles__PopupText___2gxfw","CreateCollectionForm":"styles__CreateCollectionForm___3rrk6","CreateCollectionButton":"styles__CreateCollectionButton___2zQVl","CreateCollectionInput":"styles__CreateCollectionInput___1lRyF","NotFoundImage":"styles__NotFoundImage___es5q-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollectionsPopup/styles.scss
// module id = 1404
// module chunks = 0